<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .status-banner {
    align-items: center;
    border-radius: utils.in_rem(70px);
    display: flex;
    gap: utils.in_rem(8px);
    justify-content: flex-start;
    padding: utils.in_rem(8px) utils.in_rem(12px);
    width: 100%;

    &.listen {
      background-color: colors.get(interfaceSwGrey_20);
      color: colors.get(primary_80);
    }

    &.coach {
      background-color: colors.get(primary_50);
      color: colors.get(textWhite);
    }

    &.participate {
      background-color: colors.get(accentStatusSeaGreen);
      color: colors.get(primary_80);
    }

    .text {
      @include mixins.body4;
      font-weight: 600;
      letter-spacing: utils.in_rem(0.2px);
    }
  }
</style>

<script>
  import Icon from "../../../../../../svelte-design-system/components/atoms/Icon.svelte";

  let {
    type = "listen", // "listen" | "coach" | "participate"
    userName = "",
  } = $props();
  const getIcon = (type) => {
    switch (type) {
      case "participate":
        return "fa-microphone-stand";
      case "coach":
        return "fa-headphones";
      case "listen":
      default:
        return "fa-ear";
    }
  };

  const getText = (type, name) => {
    switch (type) {
      case "listen":
        return `${name} is listening`;
      case "coach":
        return `${name} is coaching`;
      case "participate":
        return `${name} is participating`;
      default:
        return "";
    }
  };
</script>

<div class="status-banner {type}">
  <Icon class="fa-regular {getIcon(type)}" size="small" />
  <span class="text">{getText(type, userName)}</span>
</div>
